export const sources = {
	avif: "__VITE_ASSET__ApkpKaHE__ 234w",
	webp: "__VITE_ASSET__D$ezm1$5__ 234w"
};
export const img = {
	src: "__VITE_ASSET__AksK7f_a__",
	w: 234,
	h: 418
};
export default {
	sources: sources,
	img: img
};
